import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import CoverageSection from './CoverageSection';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  tabs: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
  },
  tabPanel: {
    padding: theme.spacing(2),
  },
  tabLabel: {
    fontSize: '1rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
    },
  },
}));

interface CoverageItem {
  key: string;
  label: string;
  value: string;
  visible: boolean;
}

interface AnimatedTabsProps {
  visible: boolean;
  items: CoverageItem[];
}

const AnimatedTabs: React.FC<AnimatedTabsProps> = ({ visible, items }) => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);

  const categories = Array.from(new Set(items.map((item) => item.key)));

  const tabLabels: Record<string, string> = {
    extracontractualCivilLiability: 'Responsabilidad Civil',
    coverages: 'Coberturas',
    assistances: 'Asistencias',
    additionalAssistances: 'Asistencias Adicionales',
  };

  const handleChange = (_: unknown, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box className={classes.root}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        className={classes.tabs}
        variant="scrollable"
        scrollButtons="auto">
        {categories.map((category, index) => (
          <Tab key={index} label={tabLabels[category] || category} className={classes.tabLabel} />
        ))}
      </Tabs>

      <motion.div
        key={selectedTab}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.3 }}>
        <Box className={classes.tabPanel}>
          {categories.map(
            (category, index) =>
              selectedTab === index && (
                <CoverageSection
                  key={category}
                  title={tabLabels[category] || category}
                  visible={visible}
                  items={items.filter((item) => item.key === category)}
                />
              )
          )}
        </Box>
      </motion.div>
    </Box>
  );
};

export default AnimatedTabs;
